import { render } from "./verification_step.vue?vue&type=template&id=1b421e49"
import script from "./verification_step.vue?vue&type=script&lang=js"
export * from "./verification_step.vue?vue&type=script&lang=js"

import exportComponent from "/opt/docuseal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__